{
  "Can i translate this ?": "Kan ik dit vertalen?",
  "Accounts": "Verbonden rekeningen",
  "Site settings": "Site-instellingen",
  "Language": "Taal",
  "Enable Marmaid": "Zeemeermin inschakelen",
  "Enable Blur": "Vervagen inschakelen",
  "Enable Animations": "Animaties inschakelen",
  "Personal information": "Persoonlijke informatie",
  "NO": "Nee",
  "YES": "JA",
  "General": "Algemeen",
  "Profile": "Profiel",
  "Notifications": "Meldingen",
  "Identity": "Identiteit",
  "Tokens": "Munten",
  "Instances": "Instanties",
  "Domains": "Domeinen",
  "Sessions": "Sessies",
  "My Sessions": "Mijn sessies",
  "No projects": "Geen projecten",
  "Create project": "Project aanmaken",
  "Projects": "Projecten",
  "Project name": "Naam van het project",
  "Project description": "Projectbeschrijving",
  "Select team": "Selecteer team",
  "Set unique description for project": "Stel een unieke beschrijving in voor het project",
  "Please fill out this field.": "Vul alstublieft dit veld in.",
  "Create": "Creëren",
  "OwnedBy": "Eigendom van",
  "Open": "Open",
  "Settings": "Instellingen",
  "Apps": "Apps",
  "Logout": "Uitloggen",
  "Admin": "beheerder",
  "Iot": "veel",
  "Name": "Naam",
  "Email": "E-mail",
  "You have being mentioned inside": "Je bent binnen genoemd",
  "from project": "van project",
  "by": "door",
  "You have being invited as member inside project": "Je bent uitgenodigd als lid binnen het project",
  "to build awesome things": "geweldige dingen bouwen"
}